const
	productName = "IDNLive Seamless",
	versionStr = "1.0.0",
	// Set this manually
	buildDate = new Date(2021, 11, 4)

const getBuildDateStr = () =>
	Intl.DateTimeFormat("en-GB", {
		day: "numeric",
		month: "short",
		year: "numeric"
	}).format(buildDate);

export {
	productName,
	versionStr,
	buildDate,
	getBuildDateStr
}
